module.exports = __webpack_public_path__ + "media/images/mock-thumbs/article-3-d910356d6da78e0c35097e4d957379e1.png";